const myRefs = {
  searchForm: document.querySelector('.search__form'),
  searchInput: document.querySelector('.search__input'),
  gallery: document.querySelector('.gallery'),
  loadMoreBtn: document.querySelector('.load__more'),
};

export default myRefs;
